export class ConsoleLog {
    private _level: string;
    private _className: string;
    private _message: string;

    public constructor(level: string, className: string, message: string) {
        this._level = level;
        this._className = className;
        this._message = message;
    }

    public get level(): string {
        return this._level;
    }

    public get className(): string {
        return this._className;
    }

    public get message(): string {
        return this._message;
    }
}
